<mat-toolbar class="navi mat-elevation-z2">
  <div>
    <a mat-button routerLink="">STAV</a>
  </div>
  <div *ngIf="authService.currentUser">
    <a mat-button routerLink="auftraggeber" routerLinkActive="active">Arbeitsstellen</a>
    <a mat-button routerLink="angebot" routerLinkActive="active">Angebote</a>
    <a mat-button routerLink="student" routerLinkActive="active">Studierende</a>
    <a mat-button routerLink="vermittlung" routerLinkActive="active">Vermittlungen</a>
  </div>
  <span class="spacer"></span>
  <div>
    <button [matMenuTriggerFor]="admin" mat-button routerLinkActive="active">
      Administration
      <i class="mat-menu-item-submenu-trigger"></i>
      <mat-menu #admin [overlapTrigger]=" false">
        <a mat-menu-item routerLink="admin/printed-pdf" routerLinkActive="active">PDF-Ausdrucke</a>

        <div *ngIf="authService.isAdmin">
          <a mat-menu-item routerLink="admin/statistik" routerLinkActive="active">Statistik</a>
          <a mat-menu-item routerLink="admin/aufgaben" routerLinkActive="active">Aufgaben</a>
          <a mat-menu-item routerLink="admin/rechnung" routerLinkActive="active">Rechnungen</a>
          <a mat-menu-item routerLink="admin/rechnung-aufgaben" routerLinkActive="active">Rechnungen-Aufgaben</a>
          <mat-divider></mat-divider>
          <a mat-menu-item routerLink="admin/emailtemplate" routerLinkActive="active">Email-Templates</a>
          <a mat-menu-item routerLink="admin/benutzer" routerLinkActive="active">Benutzer</a>
          <a mat-menu-item routerLink="admin/gebuehr" routerLinkActive="active">Gebühren</a>
          <a mat-menu-item routerLink="admin/kompetenz" routerLinkActive="active">Kompetenzen</a>
          <a mat-menu-item routerLink="admin/jobkategorie" routerLinkActive="active">Job-Kategorien</a>
          <a mat-menu-item routerLink="admin/jobsprachkenntnis" routerLinkActive="active">Job-Sprachkenntnisse</a>
          <a mat-menu-item routerLink="admin/jobdauer" routerLinkActive="active">Job-Dauer</a>
          <a mat-menu-item routerLink="admin/lohntyp" routerLinkActive="active">Lohntypen</a>
          <a mat-menu-item routerLink="admin/bewerbungsart" routerLinkActive="active">Bewerbungsarten</a>
          <a mat-menu-item routerLink="admin/einstellung" routerLinkActive="active">Einstellungen</a>
        </div>
      </mat-menu>
    </button>
    <button *ngIf="authService.currentUser" [matMenuTriggerFor]="user" mat-button routerLinkActive="active">
      {{authService.currentUser.login}}
      <i class="mat-menu-item-submenu-trigger"></i>
      <mat-menu #user [overlapTrigger]=" false">
        <a mat-menu-item routerLink="logout" routerLinkActive="active">Logout</a>
        <a mat-menu-item routerLink="password" routerLinkActive="active">Passwort Ändern</a>
        <mat-divider></mat-divider>
        <span mat-menu-item>{{version}}</span>
      </mat-menu>
    </button>
    <button *ngIf="!authService.currentUser" [matMenuTriggerFor]="user1" mat-button routerLinkActive="active">
      Login
      <i class="mat-menu-item-submenu-trigger"></i>
      <mat-menu #user1 [overlapTrigger]=" false">
        <span mat-menu-item>{{version}}</span>
      </mat-menu>
    </button>
  </div>
</mat-toolbar>
